import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=4f59f07a&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Merchant.vue?vue&type=style&index=1&id=4f59f07a&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59f07a",
  null
  
)

export default component.exports